<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table
          ref='account'
          title="Accounts"
          @monitor='monitor'
          @saved='saved'
          :config="config"
          @emulateUser="emulateUser"
        />


        <v-dialog
          v-model='openMonitor'
          max-width='750px'>
          <app-table
            v-if='openMonitor'
            :config='monitorConfig'
            :hidden-fields="hiddenFields"
            :api-getlist="getMonitorList"
            :item="hiddenFields"
            modal
            :filters="{ monitor_id }"
            hide-upsert
            dense
            inline-upsert
            title="Monitor Sites / Protocols"
            @close="openMonitor=false" />

        </v-dialog>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'
import monitorConfig from './config_monitor.js'
import { mapState } from 'vuex'
const { getList } = require('@/api/base_entity')
const { updateAccountProtocols } = require('@/api/user')
import { startEmulation } from '@/utils/auth'


export default {
  data () {
    return {
      config,
      monitorConfig,
      monitor_id: null,
      openMonitor: false,
    }
  },
  computed: {
    ...mapState('app', ['protocol']),
    hiddenFields () {
      if (this.protocol.id !== -1) {
        return { protocol_id: this.protocol.id, monitor_id: this.monitor_id }
      }
      return { monitor_id: this.monitor_id }
    }
  },
  methods: {
    monitor (item) {
      this.monitor_id = item.id
      this.openMonitor = true
    },
    async saved ({ data, item }) {
      if (item.site_id && item.protocols) {
        await updateAccountProtocols(item.id || data.id, item.site_id, item.protocols).catch()
      }
      this.$refs.account.getData()
    },
    async getMonitorList (entityName, filters, pagination) {
      if (this.protocol.id !== -1) {
        filters.protocol_id = this.protocol.id
      }
      return getList('monitor', filters, pagination)
    },
    emulateUser(user) {
      // this.$store.dispatch("app/startLoading")
      startEmulation(user.id)
      // location.assign('/#/dashboard')
      location.reload()
    },    
  }
}
</script>
